import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/index",
  },
  {
    path: "/index",
    component: () => import("@/views/index"),
  },
  {
    path: "/UserProtocol",
    component: () => import("@/views/UserProtocol"),
  },
];

const router = new VueRouter({
  routes,
});

export default router;
